import {sellerConstants } from '../../_constants/seller.constants';

const initialState = { creditsLoading : true, credits: '', creditsError: false};

export function credits(state = initialState, action) {
    switch (action.type) {
      case sellerConstants.REQUEST_CREDITS:
        return {
          creditsLoading: true,
          credits: '',
          creditsError: false
        };
      case sellerConstants.RECEIVE_CREDITS:
        return {
          creditsLoading: false,
          credits: action.credits.data.seller_credit_list
          ,
          creditsError: false
        };
      case sellerConstants.CREDITS_ERROR:
        return { 
          creditsLoading: false,
          credits: '',
          creditsError: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/sellers/credits.reducer.js